export const ORDER_TYPE = {
  // 个人订单
  Personal: 'personal',
  // 企业子订单
  EnterpriseSub: 'enterpriseSub',
  // 企业批量子订单
  EnterpriseSubBatch: 'enterpriseSubBatch',
}
